module.exports = __webpack_public_path__ + "static/img/pangolin.51e86226.png";